import { render } from "./IntegrationSerieButtons.vue?vue&type=template&id=705ada1c&scoped=true"
import script from "./IntegrationSerieButtons.vue?vue&type=script&lang=js"
export * from "./IntegrationSerieButtons.vue?vue&type=script&lang=js"

import "./IntegrationSerieButtons.vue?vue&type=style&index=0&id=705ada1c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705ada1c"]])

export default __exports__